window.suplantarUsuario = function (id, sello) {
    $.ajax({
        url:      urlSuplantacion,
        type:     'POST',
        dataType: 'json',
        data:     {
            searchFields: {
                id: id,
            },
            sello:        sello,
        }
    })
     .done(function (response) {
         // pNotifySuccess(response.message);

         // Si la respuesta tiene dominio, es que es un usuario pertenece a otro dominio
         if ('undefined' !== typeof response.dominio) {
             // Redireccionamos al login + suplantación por token del otro dominio
             // @DISCLAIMER Si el protocolo de un dominio a otro varía Ej: dominio 1 = ssl, dominio 2 != ssl -> Entonces la redirección fallará
             // @TODO: Gestionar el tema del protocolo del dominio por campo en la tabla empresas de la BBDD
             // @DISCLAIMER Que pasa si en el otro dominio no existe el idioma 'locale' que le pasamos desde este??
             // @TODO: Comprobar esta casuistica de error y ver que ocurre y como solucionarlo
             window.location.replace(`${window.location.protocol}//${response.dominio}/${locale}/suplantaciones/${response.auth_token}?id=${response.usuario_id}&sello=${response.sello}`);
         } else {
             // Redireccionamos a la página de inicio
             window.location.replace(urlInicio);
         }
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         }
         pNotifyError(errors);
     });
}

window.abandonarSuplantacion = function () {
    $.ajax({
        url:  urlSuplantacion,
        type: 'DELETE',
    })
     .done(function (response) {
         // Redireccionamos a la página de librerías a suplantar
         window.location.replace(urlSuplantacion);
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         }
         pNotifyError(errors);
     });
}

window.cambiarCliente = function () {
    let cambiarClienteNotify = $.confirm({
        columnClass:    'col-md-6',
        icon:           'ri-user-star-line ri-xxs',
        title:          transAccionCambiarCliente,
        type:           'green',
        content:        `<!-- Alert Error -->
                <div id="cambiarClienteError" class="alert alert-danger my-3" role="alert" style="display: none;">
                    <i class="ri-alert-fill ri-lg align-middle"></i>
                    <span></span>
                </div>
                <!-- /Alert Error -->
                <form id="cambiarClienteFormulario">
                    <div class="mb-3">
                        <label for="cambiarClienteFormularioCampoSearchFields_codigo" class="form-label">
                            ${transAccionIntroducirCampoCodigo}
                            <span class="required text-danger" aria-required="true">*</span>
                        </label>
                        <input type="number" step="1" min="1" required="true" class="form-control required" name="codigo" id="cambiarClienteFormularioCampoSearchFields_codigo" placeholder="${transAccionIntroducirCampoCodigo}" aria-required="true" aria-describedby="cambiarClienteFormularioCampoSearchFields_codigoFeedback" />
                         <div id="cambiarClienteFormularioCampoSearchFields_codigoFeedback" class="invalid-feedback"></div>
                    </div>
                    <div id="seccionSello" style="display: none">
                        <label for="cambiarClienteFormularioCampoSello" class="form-label"></label>
                        <select class="form-select" name="sello" id="cambiarClienteFormularioCampoSello" aria-describedby="cambiarClienteFormularioCampoSelloFeedback">
                        </select>
                    </div>
                    <input type="hidden" name="userId" id="idUsuarioFormularioCliente" value="">
                </form>`,
        buttons:        {
            formSubmit: {
                text:     transAccionEnviar,
                btnClass: 'btn btn-success float-end',
                action:   function () {
                    let jc = this;
                    cleanFeedback('cambiarCliente', 'cambiarClienteFormulario');
                    if (!$('#cambiarClienteFormulario')[0].checkValidity()) {
                        $('<input type="submit">')
                            .hide()
                            .appendTo(jc.$content.find('#cambiarClienteFormulario'))
                            .click()
                            .remove();
                    } else {
                        const codigoCliente = $('#cambiarClienteFormularioCampoSearchFields_codigo').val()
                        let dataToSend      = {
                            selectFields:  [
                                'users.id',
                                'users.name',
                                'users.codigo',
                                'empresas.sello',
                            ],
                            searchFields:  {
                                codigo: codigoCliente
                            },
                            join:          {
                                empresa_usuario: {
                                    on: [
                                        'users.id',
                                        'empresa_usuario.usuario_id'
                                    ],
                                },
                                empresas:        {
                                    on: [
                                        'empresas.id',
                                        'empresa_usuario.empresa_id'
                                    ],
                                },
                            },
                            primerIntento: 1,
                        }

                        if ($('#cambiarClienteFormularioCampoSello').val()) {
                            dataToSend               = {
                                searchFields: {
                                    id: $('#idUsuarioFormularioCliente').val()
                                }
                            };
                            dataToSend.sello         = $('#cambiarClienteFormularioCampoSello').val();
                            dataToSend.primerIntento = 0;
                        }

                        $.ajax({
                            url:        urlSuplantacion,
                            type:       "POST",
                            data:       dataToSend,
                            dataType:   'json',
                            beforeSend: function () {
                                jc.$$formSubmit.prop('disabled', true);
                                jc.$$formSubmit.html(`<i class="ri-loader-4-line spinner"></i> ${transAccionProcesando}`);
                            },
                        })
                         .done(function (response) {
                             if (response.showSelectorSellos) {

                                 $('#idUsuarioFormularioCliente').val(response.idUsuario);
                                 $('#seccionSello').hide();
                                 $('#cambiarClienteFormularioCampoSello select').empty()

                                 response.sellos.forEach(function (sello) {
                                     $('#cambiarClienteFormularioCampoSello').append(`<option value="${sello}">${sello}</option>`);
                                 });
                                 $('#seccionSello').show();
                                 return;
                             }
                             cambiarClienteNotify.close();
                             pNotifySuccess(response.message);
                             // viene de otra empresa
                             if (response.auth_token) {
                                 const nuevaUrl = `${window.location.protocol}//${response.dominio}/${locale}/suplantaciones/${response.auth_token}?id=${response.usuario_id}&sello=${response.sello}`;
                                 window.location.replace(nuevaUrl);
                                 return
                             }
                             window.location.replace(urlInicio);
                         })
                         .fail(function (jqXHR, status, error) {
                             console.log('fail')
                             if (jqXHR.status === 422) {
                                 errors = composeValidationError(jqXHR.responseJSON.errors);
                             } else if (jqXHR.responseJSON.message) {
                                 errors = jqXHR.responseJSON.message;
                             }
                             showInvalidFeedback(jqXHR, 'cambiarCliente', 'cambiarClienteFormulario');
                         })
                         .always(function () {
                             jc.$$formSubmit.prop('disabled', false);
                             jc.$$formSubmit.html(transAccionEnviar);
                         });
                    }
                    return false;
                },
            },
            cancel:     {
                text:     transAccionCancelar,
                btnClass: 'btn btn-light float-start',
            },
        },
        onContentReady: function () {
            // bind to events
            let jc = this;
            this.$content.find('#cambiarClienteFormularioCampoSearchFields_codigo').focus();
            this.$content.find('form').on('submit', function (e) {
                // if the user submits the form by pressing enter in the field.
                e.preventDefault();
                jc.$$formSubmit.trigger('click'); // reference the button and click it
            });
        }
    });
}
